import { c as _c } from "react/compiler-runtime";
import { Icon } from '@petsmart-ui/sparky';
import Link from 'next/link';
import { useServicesLinkClick } from '../../../../../../shared';
import './level.scss';
export type LevelEntry = {
  href?: string;
  id: string;
  label: string;
  onSelect?: (trigger: HTMLElement) => void;
  openInNewTab?: boolean;
  sale?: boolean;
};
type LevelProps = {
  entries: LevelEntry[];
  label: string;
  root?: boolean;
};
export function Level(t0) {
  const $ = _c(11);
  const {
    entries,
    label,
    root: t1
  } = t0;
  const root = t1 === undefined ? false : t1;
  const handleServicesLinkClick = useServicesLinkClick();
  const t2 = `mobile-menu-level${root ? " mobile-menu-level--root" : ""}`;
  let t3;
  if ($[0] !== entries || $[1] !== handleServicesLinkClick || $[2] !== root) {
    let t4;
    if ($[4] !== handleServicesLinkClick || $[5] !== root) {
      t4 = entry => <li key={entry.id} className="mobile-menu-level__item">{entry.href ? <Link href={entry.href} className={`mobile-menu-level__row${entry.sale ? " mobile-menu-level__row--sale" : ""}`} rel={entry.openInNewTab ? "noopener noreferrer" : undefined} target={entry.openInNewTab ? "_blank" : undefined} onClick={event => {
          handleServicesLinkClick({
            event,
            link: entry.href,
            shouldOpenInNewTab: entry.openInNewTab
          });
          entry.onSelect?.(event.currentTarget);
        }}><span>{entry.label}</span>{root && <Icon name="chevron-right" size="lg" aria-hidden="true" />}</Link> : <button type="button" className={`mobile-menu-level__row${entry.sale ? " mobile-menu-level__row--sale" : ""}`} onClick={event_0 => entry.onSelect?.(event_0.currentTarget)}><span>{entry.label}</span><Icon name="chevron-right" size="lg" aria-hidden="true" /></button>}</li>;
      $[4] = handleServicesLinkClick;
      $[5] = root;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    t3 = entries.map(t4);
    $[0] = entries;
    $[1] = handleServicesLinkClick;
    $[2] = root;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[7] !== label || $[8] !== t2 || $[9] !== t3) {
    t4 = <ul aria-label={label} className={t2}>{t3}</ul>;
    $[7] = label;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}